import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { RbTags } from 'app/shared/models/rb-tag.js';
import { StrapiApiService } from 'app/shared/services/strapi-api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-rb-tags',
  templateUrl: './rb-tags.component.html',
  styleUrls: ['./rb-tags.component.scss']
})
export class RbTagsComponent implements OnInit {

  // row data
  searchTerm = new FormControl('');
  rows: RbTags[];
  selectedValue = ''
  term: string = ''
  p = 1
  collection: any;
  selectedTags: any = [];
  searches: any = [];
  searchesCollection: any = {
    rb_collections: []
  };
  password: any = '';
  count: any;
  rbc: any;
  pageSize = 9;
  currentPage = 0;
  pageNo = 0;
  contentLength: any;
  modelFormat: any;

  constructor(private router: Router,
    public toastr: ToastrService,
    private apiService: StrapiApiService
  ) {
    if (localStorage.getItem('pt')) {
      localStorage.removeItem('pt');
    }
  }

  getTags() {
    this.apiService.getTagsGraphql().subscribe((res: any) => {
      this.rows = res;
    })
  }

  getTagsCount() {
    this.apiService.getCount('rb-collections').subscribe((res: any) => {
      this.count = res;
    })
  }

  searchTag(key) {
    this.apiService.searchTags(key).subscribe((res: any) => {
      this.searches = res;
    })
  }

  selectSearchedOption(item) {
    const index: number = this.selectedTags.findIndex(tag => {
      return tag.id === item.id
    });
    if (index === -1) {
      this.selectedTags[0] = item;
    }
    else {
      this.selectedTags.splice(index, 1);
    }
  }
  // ------------------------------------------------reset searchTags  -------------------------------------------
  resetTag() {
    this.searchesCollection.rb_collections = ''
    this.selectedTags = []
    this.term = ''
  }
  // ------------------------------------------------searchCollections by text  -------------------------------------------
  searchCollections() {
    let filter = ``;
    let i = 1;
    let j = 2;
    let t = 0
    let tagname;
    let type = '_and'
    for (let name of this.selectedTags) {
      tagname = `_where[${type}][${t}][rb_tags.name]=${name.name}&`

      // tagname = name.name
      filter += tagname;
      t++;
      type ="_or"
    };
    if (this.term) {
     let textSearchQuery =`${filter}_where[_or][0][title_contains]=${this.term}&_where[_or][1][description_contains]=${this.term}&_where[_or][2][content_1_contains]=${this.term}&_where[_or][3][content_2_contains]=${this.term}&_where[_or][4][content_3_contains]=${this.term}&_where[_or][5][content_4_contains]=${this.term}&_where[_or][6][content_5_contains]=${this.term}`
      this.apiService.searchText(textSearchQuery).subscribe(
        (res: any) => {
        this.searchesCollection.rb_collections = res
        if (!this.searchesCollection.rb_collections.length) {
          this.toastr.info('No data found')
        }
      });
    }
  }

  selectTag(data: any) {
    if (data.rb_collections.length) {
      var name = data.name;
      name = name.toLowerCase();
      name = name.replace(/ /g, "-");
      name = name.replace(/\?/g, "-");
      this.router.navigate(['/research-base/collections', name, data.id])
    } else {
      this.toastr.info('This tag contains no data')
    }
  }

  ngOnInit() {
    this.getTags();
    this.getTagsCount();
    this.searchTerm.valueChanges.subscribe(value => {
      value == '' ? this.searches = [] : this.searchTag(value)
    })
  }

  pageChange(pageNo?) {
    let checkPage = 0
    if (pageNo > checkPage) {
      pageNo = pageNo - 1;
      this.pageNo = pageNo * this.pageSize;
      this.getTags()
      checkPage = pageNo;
    } if (pageNo < checkPage) {
      this.pageNo = this.pageNo / this.pageSize;
      this.getTags()
    }
  }
}
